import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { darkActionButton } from '../styles/project-styles';
import { useNavigate } from 'react-router-dom';

import { apiUrl } from '../utils/constants';
import useFetch from '../utils/authenticated-fetch';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function AddLessonModal(props) {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [flagSent, setFlagSent] = React.useState(false);

  const authenticatedFetch = useFetch();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleSendFlag = (i) => {
    const apiForm = new FormData();
    apiForm.append('questionId', props.questionId);
    apiForm.append('flagIndex', i);
    authenticatedFetch(
      apiUrl + 'flag-question',
      {},
      {
        method: 'POST',
        body: apiForm,
      }
    ).then((msg) => {
      console.log(msg);
    });
    setFlagSent(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <p onClick={handleClickOpen}>Signaler un problème</p>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={{ m: 0, p: 2, width: '80vw' }}
          id="customized-dialog-title"
        >
          Un problème avec cette question ? 🤔
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {flagSent ? (
            <>
              <Typography>
                Merci pour ton signalement ! On va y jeter un oeil !
                🙏
              </Typography>
              <Button
                variant="contained"
                sx={{ ...darkActionButton, width: '70vw' }}
                onClick={handleClose}
              >
                Retour au quiz !
              </Button>
            </>
          ) : (
            props.flagOptions.map((item, i) => (
              <Button
                variant="contained"
                sx={{ ...darkActionButton, width: '70vw' }}
                onClick={() => handleSendFlag(i)}
              >
                {item}
              </Button>
            ))
          )}
        </DialogContent>
        {flagSent === false && (
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              Annuler
            </Button>
          </DialogActions>
        )}
      </BootstrapDialog>
    </React.Fragment>
  );
}
